var map = {
	"./AEXI_Logo.png": "0926",
	"./RVO_Logo.png": "f78e",
	"./TA_CMYK.png": "6102",
	"./Trade-Advisory-Logo2.png": "80f3",
	"./tiq_logo.png": "0b97",
	"./trade-dsm-splash.png": "d215",
	"./trade-icon-small.png": "0f36",
	"./trade-icon.png": "412f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78ca";